import { useMutation, useQueryClient } from '@tanstack/vue-query'
import fetchApi from '@/utils/fetchApi'
import type { CreateApiKeyRequest, CreateApiKeyResponse } from 'shared/src'

export function useCreateApiKeyMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: CreateApiKeyRequest) => {
      const result = await fetchApi<CreateApiKeyResponse>({
        endpoint: '/api/keys',
        method: 'POST',
        body: data,
      })
      return result
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['api-keys', 'list'] })
    },
  })
}
